import { useState } from 'react';
import { renderToString } from 'react-dom/server';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import _isEmpty from 'lodash/isEmpty';
import _isObject from 'lodash/isObject';
import _range from 'lodash/range';
import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import getConfig from 'next/config';
import numeral from 'numeral';
import { ServerStyleSheet, StyleSheetManager } from 'styled-components';
import { v4 } from 'uuid';

import CitiesLatLong from 'utils/data/citiesLatLong.json';

import { RB_THEME } from '../components/resumeBuilder/template/themes/info';
import CommonService from '../services/commonService';

import {
  CITY_SUBPAGES,
  CLUSTER_HEADER_CATEGORY,
  CMP_SUBPAGES,
  CPP_SUBPAGES,
  HOURS_IN_YEAR,
} from './constant';

const {
  publicRuntimeConfig: { ZIPPIA_STATIC_SERVER },
} = getConfig();

export const DEFAULT_COMPANY_LOGO_SRC = '../../ui-router/images/medium-company-icon.svg';
export { EVENTS, JOB_BUCKET_GROUP } from './constant';

const STATE_ABBREV = {
  alaska: 'AK',
  illinois: 'IL',
  minnesota: 'MN',
  kansas: 'KS',
  iowa: 'IA',
  wisconsin: 'WI',
  'new jersey': 'NJ',
  'new york': 'NY',
  texas: 'TX',
  'north carolina': 'NC',
  pennsylvania: 'PA',
  arizona: 'AZ',
  maine: 'ME',
  'new mexico': 'NM',
  missouri: 'MO',
  arkansas: 'AR',
  michigan: 'MI',
  tennessee: 'TN',
  georgia: 'GA',
  oklahoma: 'OK',
  florida: 'FL',
  oregon: 'OR',
  alabama: 'AL',
  'puerto rico': 'PR',
  wyoming: 'WY',
  virginia: 'VA',
  washington: 'WA',
  idaho: 'ID',
  indiana: 'IN',
  california: 'CA',
  'north dakota': 'ND',
  utah: 'UT',
  mississippi: 'MS',
  nebraska: 'NE',
  colorado: 'CO',
  'west virginia': 'WV',
  kentucky: 'KY',
  ohio: 'OH',
  'south carolina': 'SC',
  hawaii: 'HI',
  montana: 'MT',
  'south dakota': 'SD',
  louisiana: 'LA',
  maryland: 'MD',
  'new hampshire': 'NH',
  massachusetts: 'MA',
  'rhode island': 'RI',
  vermont: 'VT',
  connecticut: 'CT',
  nevada: 'NV',
  delaware: 'DE',
  'district of columbia': 'DC',
};

const STATE_NAME = {
  AK: 'Alaska',
  AL: 'Alabama',
  AR: 'Arkansas',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WY: 'Wyoming',
};

const COMPANY_CATEGORY = [
  'construction',
  'energy',
  'finance',
  'health care',
  'hospitality',
  'insurance',
  'internet',
  'manufacturing',
  'media',
  'non profits',
  'pharmaceutical',
  'real estate',
  'retail',
  'technology',
  'telecommunication',
  'transportation',
  'utilities',
  'professional',
  'automotive',
  'fortune 500',
  'biggest',
  'start up',
];

export const BLACK_LIST_WORDS = [
  '4r5e',
  '50 yard cunt punt',
  '5h1t',
  '5hit',
  'a_s_s',
  'a2m',
  'a55',
  'adult',
  'amateur',
  'anal',
  'anal impaler',
  'anal leakage',
  'anilingus',
  'anus',
  'ar5e',
  'arrse',
  'arse',
  'arsehole',
  'ass',
  'ass fuck',
  'ass-fucker',
  'ass-hole',
  'asses',
  'assfucker',
  'assfukka',
  'asshole',
  'assholes',
  'assmucus',
  'assmunch',
  'asswhole',
  'autoerotic',
  'b!tch',
  'b00bs',
  'b17ch',
  'b1tch',
  'ballbag',
  'ballsack',
  "bang (one's) box",
  'bangbros',
  'bareback',
  'bastard',
  'beastial',
  'beastiality',
  'beef curtain',
  'bellend',
  'bestial',
  'bestiality',
  'bi+ch',
  'biatch',
  'bimbos',
  'birdlock',
  'bitch',
  'bitch tit',
  'bitcher',
  'bitchers',
  'bitches',
  'bitchin',
  'bitching',
  'bloody',
  'blow job',
  'blow me',
  'blow mud',
  'blowjob',
  'blowjobs',
  'blue waffle',
  'blumpkin',
  'boiolas',
  'bollock',
  'bollok',
  'boner',
  'boob',
  'boobs',
  'booobs',
  'boooobs',
  'booooobs',
  'booooooobs',
  'breasts',
  'buceta',
  'bugger',
  'bum',
  'bunny fucker',
  'bust a load',
  'busty',
  'butt',
  'butt fuck',
  'butthole',
  'buttmuch',
  'buttplug',
  'c0ck',
  'c0cksucker',
  'carpet muncher',
  'carpetmuncher',
  'cawk',
  'chink',
  'choade',
  'chota bags',
  'cipa',
  'cl1t',
  'clit',
  'clit licker',
  'clitoris',
  'clits',
  'clitty litter',
  'clusterfuck',
  'cnut',
  'cock',
  'cock pocket',
  'cock snot',
  'cock-sucker',
  'cockface',
  'cockhead',
  'cockmunch',
  'cockmuncher',
  'cocks',
  'cocksuck',
  'cocksucked',
  'cocksucker',
  'cocksucking',
  'cocksucks',
  'cocksuka',
  'cocksukka',
  'cok',
  'cokmuncher',
  'coksucka',
  'coon',
  'cop some wood',
  'cornhole',
  'corp whore',
  'cox',
  'cum',
  'cum chugger',
  'cum dumpster',
  'cum freak',
  'cum guzzler',
  'cumdump',
  'cummer',
  'cumming',
  'cums',
  'cumshot',
  'cunilingus',
  'cunillingus',
  'cunnilingus',
  'cunt',
  'cunt hair',
  'cunt-struck',
  'cuntbag',
  'cuntlick',
  'cuntlicker',
  'cuntlicking',
  'cunts',
  'cuntsicle',
  'cut rope',
  'cyalis',
  'cyberfuc',
  'cyberfuck',
  'cyberfucked',
  'cyberfucker',
  'cyberfuckers',
  'cyberfucking',
  'd1ck',
  'damn',
  'dick',
  'dick hole',
  'dick shy',
  'dickhead',
  'dildo',
  'dildos',
  'dink',
  'dinks',
  'dirsa',
  'dirty Sanchez',
  'dlck',
  'dog-fucker',
  'doggie style',
  'doggiestyle',
  'doggin',
  'dogging',
  'donkeyribber',
  'doosh',
  'duche',
  'dyke',
  'eat a dick',
  'eat hair pie',
  'ejaculate',
  'ejaculated',
  'ejaculates',
  'ejaculating',
  'ejaculatings',
  'ejaculation',
  'jakulate',
  'erotic',
  'f u c k',
  'f u c k e r',
  'f_u_c_k',
  'f4nny',
  'facial',
  'fag',
  'fagging',
  'faggitt',
  'faggot',
  'faggs',
  'fagot',
  'fagots',
  'fags',
  'fanny',
  'fannyflaps',
  'fannyfucker',
  'fanyy',
  'fatass',
  'fcuk',
  'fcuker',
  'fcuking',
  'feck',
  'fecker',
  'felching',
  'fellate',
  'fellatio',
  'fingerfuck',
  'fingerfucked',
  'fingerfucker',
  'fingerfuckers',
  'fingerfucking',
  'fingerfucks',
  'fist fuck',
  'fistfuck',
  'fistfucked',
  'fistfucker',
  'fistfuckers',
  'fistfucking',
  'fistfuckings',
  'fistfucks',
  'flange',
  'flog the log',
  'fook',
  'fooker',
  'fuck',
  'fuck hole',
  'fuck puppet',
  'fuck trophy',
  'fuck yo mama',
  'fuck-ass',
  'fuck-bitch',
  'fucka',
  'fucked',
  'fucker',
  'fuckers',
  'fuckhead',
  'fuckheads',
  'fuckin',
  'fucking',
  'fuckings',
  'fuckingshitmotherfucker',
  'fuckme',
  'fuckmeat',
  'fucks',
  'fucktoy',
  'fuckwhit',
  'fuckwit',
  'fudge packer',
  'fudgepacker',
  'fuk',
  'fuker',
  'fukker',
  'fukkin',
  'fuks',
  'fukwhit',
  'fukwit',
  'fux',
  'fux0r',
  'gang-bang',
  'gangbang',
  'gangbang',
  'gangbanged',
  'gangbangs',
  'gassy ass',
  'gaylord',
  'gaysex',
  'goatse',
  'god',
  'god damn',
  'god-dam',
  'god-damned',
  'goddamn',
  'goddamned',
  'ham flap',
  'hardcoresex',
  'hell',
  'heshe',
  'hoar',
  'hoare',
  'hoer',
  'homo',
  'homoerotic',
  'hore',
  'horniest',
  'horny',
  'hotsex',
  'how to kill',
  'how to murdep',
  'jack-off',
  'jackoff',
  'jap',
  'jerk',
  'jerk-off',
  'jism',
  'jiz',
  'jizm',
  'jizz',
  'kawk',
  'kinky Jesus',
  'knob',
  'knob end',
  'knobead',
  'knobed',
  'knobend',
  'knobend',
  'knobhead',
  'knobjocky',
  'knobjokey',
  'kock',
  'kondum',
  'kondums',
  'kum',
  'kummer',
  'kumming',
  'kums',
  'kunilingus',
  'kwif',
  'l3i+ch',
  'l3itch',
  'labia',
  'LEN',
  'lmao',
  'lmfao',
  'lmfao',
  'lust',
  'lusting',
  'm0f0',
  'm0fo',
  'm45terbate',
  'ma5terb8',
  'ma5terbate',
  'mafugly',
  'masochist',
  'master-bate',
  'masterb8',
  'masterbat*',
  'masterbat3',
  'masterbate',
  'masterbation',
  'masterbations',
  'masturbate',
  'mo-fo',
  'mof0',
  'mofo',
  'mothafuck',
  'mothafucka',
  'mothafuckas',
  'mothafuckaz',
  'mothafucked',
  'mothafucker',
  'mothafuckers',
  'mothafuckin',
  'mothafucking',
  'mothafuckings',
  'mothafucks',
  'mother fucker',
  'mother fucker',
  'motherfuck',
  'motherfucked',
  'motherfucker',
  'motherfuckers',
  'motherfuckin',
  'motherfucking',
  'motherfuckings',
  'motherfuckka',
  'motherfucks',
  'muff',
  'muff puff',
  'mutha',
  'muthafecker',
  'muthafuckker',
  'muther',
  'mutherfucker',
  'n1gga',
  'n1gger',
  'nazi',
  'need the dick',
  'nigg3r',
  'nigg4h',
  'nigga',
  'niggah',
  'niggas',
  'niggaz',
  'nigger',
  'niggers',
  'nob',
  'nob jokey',
  'nobhead',
  'nobjocky',
  'nobjokey',
  'numbnuts',
  'nut butter',
  'nutsack',
  'omg',
  'orgasim',
  'orgasims',
  'orgasm',
  'orgasms',
  'p0rn',
  'pawn',
  'pecker',
  'penis',
  'penisfucker',
  'phonesex',
  'phuck',
  'phuk',
  'phuked',
  'phuking',
  'phukked',
  'phukking',
  'phuks',
  'phuq',
  'pigfucker',
  'pimpis',
  'piss',
  'pissed',
  'pisser',
  'pissers',
  'pisses',
  'pissflaps',
  'pissin',
  'pissing',
  'pissoff',
  'poop',
  'porn',
  'porno',
  'pornography',
  'pornos',
  'prick',
  'pricks',
  'pron',
  'pube',
  'pusse',
  'pussi',
  'pussies',
  'pussy',
  'pussy fart',
  'pussy palace',
  'pussys',
  'queaf',
  'queer',
  'rectum',
  'retard',
  'rimjaw',
  'rimming',
  's hit',
  's_h_i_t',
  's.o.b.',
  'sadism',
  'sadist',
  'sandbar',
  'sausage queen',
  'schlong',
  'screwing',
  'scroat',
  'scrote',
  'scrotum',
  'semen',
  'sex',
  'sh!+',
  'sh!t',
  'sh1t',
  'shag',
  'shagger',
  'shaggin',
  'shagging',
  'shemale',
  'shi+',
  'shit',
  'shit fucker',
  'shitdick',
  'shite',
  'shited',
  'shitey',
  'shitfuck',
  'shitfull',
  'shithead',
  'shiting',
  'shitings',
  'shits',
  'shitted',
  'shitter',
  'shitters',
  'shitting',
  'shittings',
  'shitty',
  'skank',
  'slope',
  'slut',
  'slut bucket',
  'sluts',
  'smegma',
  'smut',
  'snatch',
  'son-of-a-bitch',
  'spac',
  'spunk',
  't1tt1e5',
  't1tties',
  'teets',
  'teez',
  'testical',
  'testicle',
  'tit',
  'tit wank',
  'titfuck',
  'tits',
  'titt',
  'tittie5',
  'tittiefucker',
  'titties',
  'tittyfuck',
  'tittywank',
  'titwank',
  'tosser',
  'turd',
  'tw4t',
  'twat',
  'twathead',
  'twatty',
  'twunt',
  'twunter',
  'v14gra',
  'v1gra',
  'vagina',
  'viagra',
  'vulva',
  'w00se',
  'wang',
  'wank',
  'wanker',
  'wanky',
  'whoar',
  'whore',
  'willies',
  'willy',
  'wtf',
  'xrated',
  'xxx',
];

const EXTENDED_LOCATIONS = [
  'remote',
  'work from home',
  'remote (work from home)',
  'telecommute (work from home)',
  'virtual (work from home)',
];

const passwordBlacklist = ['password', 'zippia'];

const COMPANY_CATEGORY_OBJ = [
  {
    text: 'top overall',
    url: '',
    noFollow: false,
    prioritizeOrder: true,
    alwaysIncluded: true,
  },
  {
    text: 'most diverse',
    url: 'most-diverse',
    noFollow: false,
    prioritizeOrder: true,
    isTest: true,
  },
  {
    text: 'best paying',
    url: 'best paying',
    noFollow: false,
    prioritizeOrder: true,
    isTest: true,
  },
  {
    text: 'construction',
    url: 'construction',
    noFollow: false,
    industryUrl: '/construction-and-extraction-industry/',
  },
  {
    text: 'energy',
    url: 'energy',
    noFollow: false,
    industryUrl: '/production-and-manufacturing-industry/',
  },
  {
    text: 'finance',
    url: 'finance',
    noFollow: false,
    industryUrl: '/business-and-financial-industry/',
  },
  {
    text: 'health care',
    url: 'health-care',
    noFollow: false,
    industryUrl: '/healthcare-practitioner-and-technical-industry/',
  },
  {
    text: 'hospitality',
    url: 'hospitality',
    noFollow: false,
    industryUrl: '/food-preparation-and-restaurant-industry/',
  },
  {
    text: 'insurance',
    url: 'insurance',
    noFollow: false,
    industryUrl: '/office-and-administrative-industry/',
  },
  {
    text: 'internet',
    url: 'internet',
    noFollow: false,
    industryUrl: '/executive-management-industry/',
  },
  {
    text: 'manufacturing',
    url: 'manufacturing',
    noFollow: false,
    industryUrl: '/production-and-manufacturing-industry/',
  },
  {
    text: 'education',
    url: 'education',
    noFollow: false,
    industryUrl: '/education-training-and-library-industry/',
  },
  { text: 'government', url: 'government', noFollow: false, industryUrl: '/military-industry/' },
  {
    text: 'agriculture',
    url: 'agriculture',
    noFollow: false,
    industryUrl: '/architecture-and-engineering-industry/',
  },
  {
    text: 'media',
    url: 'media',
    noFollow: false,
    industryUrl: '/arts-entertainment-sports-and-media-industry/',
  },
  {
    text: 'non profits',
    url: 'non-profits',
    noFollow: false,
    industryUrl: '/community-and-social-services-industry/',
  },
  {
    text: 'pharmaceutical',
    url: 'pharmaceutical',
    noFollow: false,
    industryUrl: '/healthcare-support-industry/',
  },
  { text: 'real estate', url: 'real-estate', noFollow: false, industryUrl: '/legal-industry/' },
  { text: 'retail', url: 'retail', noFollow: false, industryUrl: '/sales-industry/' },
  {
    text: 'technology',
    url: 'technology',
    noFollow: false,
    industryUrl: '/computer-and-mathematical-industry/',
  },
  {
    text: 'telecommunication',
    url: 'telecommunication',
    noFollow: false,
    industryUrl: '/architecture-and-engineering-industry/',
  },
  {
    text: 'transportation',
    url: 'transportation',
    noFollow: false,
    industryUrl: '/transportation-industry/',
  },
  {
    text: 'utilities',
    url: 'utilities',
    noFollow: false,
    industryUrl: '/installation-maintenance-and-repair-industry/',
  },
  { text: 'professional', url: 'professional', noFollow: false, industryUrl: '/sales-industry/' },
  {
    text: 'automotive',
    url: 'automotive',
    noFollow: false,
    industryUrl: '/transportation-industry/',
  },
  {
    text: 'fortune 500',
    url: 'fortune-500',
    noFollow: false,
    industryUrl: '/business-and-financial-industry/',
  },
  {
    text: 'biggest',
    url: 'biggest',
    noFollow: false,
    industryUrl: '/executive-management-industry/',
  },
  {
    text: 'start-up',
    url: 'start-up',
    noFollow: false,
    industryUrl: '/executive-management-industry/',
  },
];

const getCityLatLong = function (city, stateAbb) {
  //const fs = require('fs');
  //const jsonData = fs.readFileSync(jsonFile);
  return CitiesLatLong[city + ',' + stateAbb] || {};
};

// Load locale
dayjs.locale('en-au');
// Load relative time plugin
dayjs.extend(relativeTime);

// LOOK: filter.js
export function fromNow(date) {
  return dayjs(date).fromNow();
}

/**
 * Returns current Month And Year
 * @example {month: "August", year: 1999}
 * @returns {{ month: string, year: number }}
 */
export function getCurrentMonthYear() {
  const date = new Date();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();
  return { month, year };
}

export const getLastUpdatedDate = (metadata = {}) => {
  const { UPDATED_TIME } = metadata;
  const dateFormat = 'MMMM D, YYYY';
  return UPDATED_TIME ? dayjs(UPDATED_TIME).format(dateFormat) : dayjs().format(dateFormat);
};

export function greaterThanTwoMonths(jobPostingDate) {
  const today = dayjs();
  const diff = today.diff(dayjs(jobPostingDate), 'months', true);
  return diff > 2;
}

export function formatCurrencyRevenue(amount, formatMillions = '($0.0a)') {
  let amountStringFormatted;
  if (amount) {
    if (amount.toString().length > 6) {
      amountStringFormatted = numeral(Number(amount)).format(formatMillions);
    } else {
      amountStringFormatted = numeral(Number(amount)).format('$0,0');
    }
    return amountStringFormatted.toUpperCase();
  }
  return null;
}

export function formatCurrencyRevenueWholeWord(amount) {
  let amountStringFormatted;
  if (amount) {
    if (amount.toString().length > 6) {
      amountStringFormatted = numeral(Number(amount)).format('($0.0a)');
      const wholeWord = {
        m: 'Million',
        b: 'Billion',
        t: 'Trillion',
      };
      const abbrev = amountStringFormatted.slice(-1);
      amountStringFormatted = `${amountStringFormatted.slice(0, -1)} ${wholeWord[abbrev]}`;
    } else {
      amountStringFormatted = numeral(Number(amount)).format('$0,0');
    }
    return amountStringFormatted;
  }
  return null;
}

export function formatNumber(value) {
  return numeral(value).format('0,0');
}

export function formatNumberIntl(val) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
}

export function generateRandomKey() {
  return v4();
}

export function generateKey(key) {
  const uuid = Math.ceil(Math.random(2 ** 5, 2 ** 6) * 10 ** 12);
  if (typeof key === 'string' || typeof key === 'number') {
    return `${key}_${uuid}`;
  }
  return uuid;
}

export function encodeBase64(str) {
  return Buffer.from(str).toString('base64');
}

export function generateKeyForList(index, ...data) {
  try {
    let key = data.map((x) => encodeBase64(x)).join('_');
    key = `${index}_${key.substring(0, 10)}`;
    return key;
  } catch {
    return index;
  }
}

export function isEmptyObj(obj) {
  return !obj || Object.keys(obj).length === 0;
}
export function replaceExpressionToValue(stringInput, expr, value) {
  return stringInput.replace(expr, value);
}

export const doubleEncodeString = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return escape(encodeURIComponent(value));
};

export const stringStartWithMulti = (string, values, ignoreCase) => {
  if (typeof string !== 'string' || !Array.isArray(values)) {
    return false;
  }
  if (ignoreCase) {
    return values.some((item) => string.toLowerCase().startsWith(item.toLowerCase()));
  }
  return values.some((item) => string.startsWith(item));
};

export const stringIncludesAny = (string, values, ignoreCase) => {
  if (typeof string !== 'string' || !Array.isArray(values)) {
    return false;
  }
  if (ignoreCase) {
    return values.some((item) => string.toLowerCase().includes(item.toLowerCase()));
  }
  return values.some((item) => string.includes(item));
};

export function buildUrl(url, host) {
  return (host || '') + url.replace(/ /g, '-').replace(/[,()]/g, '').toLowerCase();
}

export function validateEmail(email) {
  const basic = /^[ A-Za-z0-9_@./#&+-]*$/;
  const addvance =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return basic.test(email) && addvance.test(email);
}

export function validatePhoneNumber(phoneNumber) {
  phoneNumber = phoneNumber.replace(/\D/g, '');
  return phoneNumber && phoneNumber.length > 7;
}

/**
 * @param {string} password
 * @param {boolean} explain - whether to return an object with details about the test results.
 * @return {boolean|{
 *  isValid: boolean,
 *  isBlacklisted: boolean,
 *  isRepeatingPattern: boolean,
 *  isShort: boolean
 * }}
 */
export function validatePassword(password, explain = false) {
  if (!password) return explain ? {} : false;

  const isNotInBlacklist = !passwordBlacklist.some((item) => password.toLowerCase().includes(item));
  const isNotRepeated =
    password.split('').filter((l) => l === password[0]).length !== password.length;
  const isNotShort = password.length >= 8;

  if (explain) {
    return {
      isValid: isNotInBlacklist && isNotRepeated && isNotShort,
      isBlacklisted: !isNotInBlacklist,
      isRepeatingPattern: !isNotRepeated,
      isShort: !isNotShort,
    };
  }

  return isNotInBlacklist && isNotRepeated && isNotShort;
}

export function isZipCode(value) {
  const regex = /^[0-9]*$/;
  return regex.test(value);
}

/**
 * @return true of completely visible elements in view.
 * @param element : DOM element.
 */
export function isScrolledIntoView(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= window.innerHeight;
}

export function getStateAbbr(state = '') {
  if (!state) return '';
  const stateName = state.trim().toLowerCase();
  return STATE_ABBREV[stateName] || state;
}

/**
 * return {city: 'California City', state: 'California', stateAbbr: 'CA'}
 * @param location
 */

export function splitLocation(location) {
  if (!location) {
    return;
  }
  let city;
  let state;
  let stateCode;
  // A city or state will never have "," in it's name. So splitting the location by "," will always give to city and state.
  const splitArray = location.split(', ');
  if (splitArray.length === 1) {
    // In case of state, it's state name but not state code.
    state = splitArray[0];
    stateCode = getStateAbbr(state);
  } else {
    city = splitArray[0];
    stateCode = splitArray[1];
    state = STATE_NAME[stateCode];
  }
  return {
    city,
    state,
    stateAbbr: stateCode,
  };
}

export function getStateName(abbr = '') {
  if (!abbr) {
    return '';
  }
  const stateAbbr = abbr.trim().toUpperCase();
  return STATE_NAME[stateAbbr] || abbr;
}

export const isStateName = (state) => {
  if (!state || typeof state !== 'string') {
    return false;
  }
  return !!STATE_ABBREV[state.toLowerCase()];
};

export const isStateAbbr = (state) => {
  if (!state || typeof state !== 'string') {
    return false;
  }
  return !!STATE_NAME[state];
};

export function toTitleCase(str) {
  str = str || '';
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export function trimHyphen(s) {
  return s.replace(/^[-]+|[-]+$/g, '');
}

export function removeSpecialCharacter(str) {
  if (!str) {
    return null;
  }
  /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/
  while (true) {
    const newStr = str.replace(/[^A-Z0-9]+/gi, '-').trim();
    if (str === newStr) {
      return trimHyphen(newStr);
    }
    str = newStr;
  }
}

export function buildJobTitleSingleReviewPageUrl(jobTitle, reviewId, host) {
  // URL pattern for Job Title Single Review Page: /reviews/job-review-<jobTitle>-<review_id>/
  if (jobTitle && reviewId) {
    const jobTitleForUrl = removeSpecialCharacter(jobTitle);
    const slug = `/${jobTitleForUrl}-jobs/#review-${reviewId}`;
    host = host || '';
    return buildUrl(slug, host);
  }
  return '';
}

export function buildCityPageUrl(city, state, subPage) {
  if (!city && !state) return;
  let url = city
    ? `/${removeSpecialCharacter(city)}-${getStateAbbr(state)}-jobs/`
    : `/${removeSpecialCharacter(state)}-jobs/`;
  if (subPage) url = url + `${subPage}/`;
  return url.toLowerCase();
}

export function buildCMPPageUrl(jobTitle) {
  if (!jobTitle) return;
  const url = `/${removeSpecialCharacter(jobTitle)}-jobs/`;
  return url.toLowerCase();
}

export function buildCMPSalaryPageUrl(jobTitle) {
  if (!jobTitle) return;
  const url = `/${removeSpecialCharacter(jobTitle)}-jobs/salary/`;
  return url.toLowerCase();
}

export const isValidCompanyCategory = (category) =>
  COMPANY_CATEGORY.indexOf(category.toLowerCase().replace('-', ' ')) != -1;

/**
 * Build URL for company sitemap city pages (BCP for City).
 * Note: for companyCategory param, if the value is "Without-Category", we will generate BCP for State URL (without category).
 * @param city: city name.
 * @param stateAbbr: state abbr. (NOT state name), for example: CA, DC.
 * @param companyCategory: company category, this param is optional, only specify it when we need to generate BCP URL for City by company category.
 * @returns Company sitemap page URL for the city, format: "/company/best-companies-in-<city-name>-<state_abbr>/".
 * @example Company sitemap URL for city "San Mateo, CA": "/company/best-companies-in-san-mateo-ca/".
 */
export const buildCompanySitemapCityUrl = (city, stateAbbr, companyCategory) => {
  if (!city || !stateAbbr || stateAbbr.length != 2) {
    return null;
  }

  const cityNameInUrl = removeSpecialCharacter(city).toLowerCase();
  const stateAbbrInUrl = stateAbbr.toLowerCase().trim().replace(/ /g, '-');
  if (companyCategory && isValidCompanyCategory(companyCategory)) {
    // Generate BCP URL for City by company category.
    const companyCategoryInUrl = removeSpecialCharacter(companyCategory);
    return `/company/best-${companyCategoryInUrl}-companies-in-${cityNameInUrl}-${stateAbbrInUrl}/`;
  }
  // Generate BCP URL for City (without company category).
  return `/company/best-companies-in-${cityNameInUrl}-${stateAbbrInUrl}/`;
};

export const isValidExtendedLocation = (location) =>
  EXTENDED_LOCATIONS.includes(location.toLowerCase());

export function formatCurrency(amount) {
  return numeral(amount).format('$0,0');
}

export function formatCurrencyWithTwoDecimals(amount) {
  return numeral(amount).format('$0,0.00');
}

/**
 * Parse and mask a number string. Final format is: 1,234,567.89.
 * @param {string} value - The number string to parse.
 * @param {number} maxDecimalPlaces - The maximum number of decimal places.
 * @returns {string} The masked number string.
 */
export const formatDecimal = (value = '0', maxDecimalPlaces = 2) => {
  // Remove extra decimal points.
  const nonRepeating = value
    .split('.')
    .reduce((acc, curr, idx) => acc + (idx === 1 ? '.' : '') + curr, '');
  // Remove non-numerics and leading zeros.
  const decimal = nonRepeating.replace(/[^0-9.]/g, '').replace(/^0+/, '');
  // Limits the decimal places.
  const limitedDecimal = decimal.replace(new RegExp(`(\\.\\d{${maxDecimalPlaces}})\\d+`), '$1');
  // Add a comma to every third digit from the right.
  const partiallyGrouped = limitedDecimal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  // Remove commas after the decimal point.
  // Please note that Safari only added support for Regex lookbehind in December 22!
  const maskedDecimal = partiallyGrouped.replace(/(^[\d,]*\.+.*),/g, '$1');
  return maskedDecimal;
};

export function formatCurrencyAbbreviation(amount) {
  if (!amount) return null;
  const valueAmount = numeral(amount).value();
  if (typeof valueAmount !== 'number') return null;

  const billion = 1000000000;
  const hundredMillion = 100000000;
  const million = 1000000;
  const hundredThousand = 100000;

  const millionQuotient = Math.floor(valueAmount / million);
  const millionRemainder = valueAmount % million;

  const billionQuotient = Math.floor(valueAmount / billion);
  const billionRemainder = valueAmount % billion;
  let formattedAmount;

  // billion
  if (billionQuotient >= 1) {
    if (billionRemainder >= hundredMillion) {
      formattedAmount = numeral(amount).format('$0.0a');
    } else {
      formattedAmount = numeral(amount).format('$0a');
    }
  } else if (millionQuotient >= 1) {
    if (millionRemainder >= hundredThousand) {
      formattedAmount = numeral(amount).format('$0.0a');
    } else {
      formattedAmount = numeral(amount).format('$0a');
    }
  } else {
    formattedAmount = numeral(amount).format('$0a');
  }
  return formattedAmount?.toUpperCase();
}

export function kCurrencyFormatter(amountValue, withDollar = false) {
  const amount = typeof amountValue !== 'number' ? numeral(amountValue).value() : amountValue;
  const sign = Math.sign(amount);
  const absoluteValue = Math.abs(amount);
  const resultingAmount =
    absoluteValue > 999 ? `${sign * (absoluteValue / 1000).toFixed(0)}k` : sign * absoluteValue;
  return `${withDollar ? '$' : ''}${resultingAmount}`;
}

export function isFBInAppBrowser() {
  return navigator.userAgent.match(/iPad|iPhone|iPod/i) && navigator.userAgent.match(/FBMD/i);
}

export const isIE = function () {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
};

export const isChrome = () =>
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export const ismobileDevice = function () {
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }
  return false;
};

export const divideListInNColumns = function (list, noOfColumns) {
  if (!list) {
    return [];
  }
  let i;
  const totalItemsByX = Math.ceil(list.length / noOfColumns);
  const result = [];
  for (i = 0; i < noOfColumns; i++) {
    result.push(list.slice(i * totalItemsByX, (i + 1) * totalItemsByX));
  }
  return result;
};

export const isPhone = function () {
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  return false;
};

export const isAndroidDevice = function () {
  return /Android/i.test(navigator.userAgent);
};

export const isIpadDevice = function () {
  return /iPad/i.test(navigator.userAgent);
};

export const isiPhoneSafari = function () {
  return (
    navigator.userAgent.match(/iPhone/i) &&
    navigator.userAgent.match(/WebKit/i) &&
    !navigator.userAgent.match(/CriOS/i)
  );
};

export const loadServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js', {
      updateViaCache: 'none',
      scope: '/',
    });
  }
};

export const isBrowser = () => typeof window !== 'undefined';

export const isDevEnv = () => {
  if (isBrowser()) {
    const hostDomain = window?.location?.hostname;
    return hostDomain?.includes('dev.zippia.com');
  }
  return false;
};

/**
 *
 * @param {import('next/app').NextWebVitalsMetric} metric
 */
export const sendAnalytics = async (metric) => {
  // 2. Initialize the Bugfender service
  if (isDevEnv()) {
    const { name, value } = metric;
    // 3. Add condition to tackle the metrics
    if (name === 'FCP') {
      if (value > 4000) {
        CommonService.analyticsToLog(
          `${name} value ${value} is completly out of range and the speed is slow in url: ${window.location.href}.`
        );
      }
    } else if (name === 'CLS') {
      if (value > 0.25) {
        CommonService.analyticsToLog(
          `${name} value ${value} is completly out of range and the speed is slow in url: ${window.location.href}.`
        );
      }
    } else if (name === 'FID') {
      if (value > 300) {
        CommonService.analyticsToLog(
          `${name} value ${value} is completly out of range and the speed is slow in url: ${window.location.href}.`
        );
      }
    }
  }
};

// safari version of 10 or older
export const isOldVersionOfSafari = function () {
  return (
    navigator.userAgent.match(/Safari/i) &&
    !navigator.userAgent.match(/Chrome/i) &&
    navigator.userAgent.match(/Version\/(\d*)/)[1] <= 10
  );
};

export const format = (str, replacer) =>
  Object.keys(replacer).reduce(
    (newStr, value) => newStr.replace(RegExp(`\\{${value}\\}`, 'gi'), replacer[value]),
    str
  );

// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
export const resizeViewHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const buildComboCmpUrl = (jobTitle, jobLocation, host = '') => {
  const title = removeSpecialCharacter(jobTitle);
  const location = removeSpecialCharacter(jobLocation);

  const url = `/${title}-${location}-jobs/`;
  return buildUrl(url, host);
};

export const buildSitemapLocationsPageUrl = (jobTitle, industry, host = '') => {
  const formattedIndustry = removeSpecialCharacter(industry);
  const formattedJobTitle = removeSpecialCharacter(jobTitle);
  return `${buildUrl(`${formattedIndustry}-industry`, host)}/${buildUrl(
    formattedJobTitle
  )}/locations/`;
};

export const buildIndustryPageUrl = (industry) => {
  const industryObj = COMPANY_CATEGORY_OBJ.find(
    ({ text }) => text === (industry || '').toLowerCase()
  );
  return industryObj ? industryObj.industryUrl : undefined;
};

export const buildUrlUsingTitleAndLocation = (jobTitle, jobLocation, host) => {
  let url;
  // Navigate to respective page based on the search criteria
  let title;
  let location;
  let slug;

  if (jobTitle) {
    title = removeSpecialCharacter(jobTitle);
  }
  if (jobLocation) {
    location = removeSpecialCharacter(jobLocation);
  }

  if (jobTitle && jobLocation) {
    // Go to career page.
    slug = `${title} ${location}`;
  } else if (jobTitle && !jobLocation) {
    // Go to career page.
    slug = title;
  } else if (jobLocation) {
    // If title is not defined and only location is defined then go to Job Listing Page.
    slug = location;
  }

  if (slug) slug += '-jobs';

  if (slug) url = `/${slug}/`;

  if (url) {
    return buildUrl(url, host);
  }
  return '';
};

/**
 * Importing from static server
 *
 * @param {String} url - import url
 */
export const importStatic = (url) => `${ZIPPIA_STATIC_SERVER}${url}`;

/**
 * Returns url of two sizes of skills image
 * @param {string} jobTitle
 * @returns {{large:'',extraLarge:''}}
 */
export const buildSkillImageUrlUsingTitle = (jobTitle) => {
  if (!jobTitle) return {};

  const _title = removeSpecialCharacter(jobTitle).toLowerCase();

  const lg = `/skills-images/${_title}-skills-1200x675.png`;
  const xl = `/skills-images/${_title}-skills-2400x1350.png`;

  return {
    large: importStatic(lg),
    extraLarge: importStatic(xl),
  };
};

/**
 * Build URL for CPP Subpages.
 * URL Pattern: use CPP url and add subpage category (from CONSTANTS.CPP_SUBPAGES). (example: /amazon-careers-487/salary/).
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @param {string} page - Required, CPP subpage type, defined in CONSTANTS.CPP_SUBPAGES.
 */
export const buildCppSubpageUrl = (cppUrl, host = '', subpageType) => {
  if (!cppUrl || !subpageType) return '';
  if (subpageType === CPP_SUBPAGES.OVERVIEW) {
    return (host || '') + cppUrl;
  }
  // Note: No need to call this.buildUrl() function here, because it converts URL to lowercase;
  // since Company Pipeline has the full control of CPP URL, we should use that directly, and do not convert it.
  return `${(host || '') + cppUrl + subpageType}/`;
};

/**
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {*} jobTitle  - Requried
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @returns Company Job Title Jobs Page Url
 */
export const buildCompanyJobsJobTitleUrl = (cppUrl, jobTitle, host = '') => {
  const cppJobUrl = buildCppSubpageUrl(cppUrl, host, CPP_SUBPAGES.JOBS);
  return cppJobUrl + removeSpecialCharacter(jobTitle)?.toLowerCase() + '/';
};

/**
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {*} jobTitle  - Requried
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @returns Company Job Title Salary Page Url
 */
export const buildCompanyJobTitleSalaryUrl = (cppUrl, jobTitle, host = '') => {
  const cppJobUrl = buildCppSubpageUrl(cppUrl, host, CPP_SUBPAGES.SALARY);
  return cppJobUrl + removeSpecialCharacter(jobTitle)?.toLowerCase() + '/';
};

/**
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {*} city  - Requried
 * @param {*} stateCode  - Requried
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @returns Company City Salary Page Url
 */
export const buildCompanyCitySalaryUrl = (cppUrl, city, stateCode, host = '') => {
  const cppJobUrl = buildCppSubpageUrl(cppUrl, host, CPP_SUBPAGES.SALARY);
  const loc = city + '-' + stateCode;
  return cppJobUrl + removeSpecialCharacter(loc)?.toLowerCase() + '/';
};

/**
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {*} stateNameOrAbbr  - Requried
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @returns Company State Salary Page Url
 */
export const buildCompanyStateSalaryUrl = (cppUrl, stateNameOrAbbr, host = '') => {
  const cppJobUrl = buildCppSubpageUrl(cppUrl, host, CPP_SUBPAGES.SALARY);
  const stateName = isStateAbbr(stateNameOrAbbr) ? getStateName(stateNameOrAbbr) : stateNameOrAbbr;
  return cppJobUrl + removeSpecialCharacter(stateName)?.toLowerCase() + '/';
};

/**
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {string} city  - Requried
 * @param {string} stateCode  - Requried
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @returns Company Location Jobs Page Url
 */
export const buildCompanyJobsCityUrl = (cppUrl, city, stateCode, host = '') => {
  const cppJobUrl = buildCppSubpageUrl(cppUrl, host, CPP_SUBPAGES.JOBS);
  return cppJobUrl + removeSpecialCharacter(city + ' ' + stateCode)?.toLowerCase() + '/';
};

/**
 * Build URL for CMP Subpages.
 * URL Pattern: use CMP url and add subpage category (from CONSTANTS.CMP_SUBPAGES). (example: /product-manager-jobs/skills/).
 * Note: For Combo CMPs, they would just point to the base CMP url; ie /product-manager-san-jose-ca-jobs/ would link or point to /product-manager-jobs/skills/.
 * @param {string} jobTitle - Required, job title.
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @param {string} subpageType - Required, CMP Subpage type, defined in CONSTANTS.CMP_SUBPAGES.
 * @param {string} customSubPageName - Optional, but required when subpageType is CONSTANTS.CMP_SUBPAGES.DYNAMIC.
 * @param {string} jobTitleArticle - Optional, but required when subpageType is CONSTANTS.CMP_SUBPAGES.WHAT_THEY_DO, values: “a” or “an”.
 */
export const buildCmpSubpagesUrls = (
  jobTitle,
  host = '',
  subpageType,
  customSubPageName = '',
  jobTitleArticle = ''
) => {
  if (!jobTitle || !subpageType) return '';
  // Check params values when subpageType is CMP_SUBPAGES.DYNAMIC.
  if (subpageType === CMP_SUBPAGES.DYNAMIC && !customSubPageName) return '';
  // Check params values when subpageType is CMP_SUBPAGES.WHAT_THEY_DO.
  if (subpageType === CMP_SUBPAGES.WHAT_THEY_DO && !jobTitleArticle) return '';

  const cmpUrl = buildUrlUsingTitleAndLocation(jobTitle, '', host);
  const jobTitleForUrl = removeSpecialCharacter(jobTitle).toLowerCase();
  if (cmpUrl) {
    switch (subpageType) {
      case CMP_SUBPAGES.SKILLS:
      case CMP_SUBPAGES.BEST_STATES:
      case CMP_SUBPAGES.SALARY:
      case CMP_SUBPAGES.JOBS:
      case CMP_SUBPAGES.REMOTE_JOBS:
      case CMP_SUBPAGES.TRENDS:
      case CMP_SUBPAGES.EDUCATION:
      case CMP_SUBPAGES.DEMOGRAPHICS:
      case CMP_SUBPAGES.DESCRIPTION:
      case CMP_SUBPAGES.CERTIFICATIONS:
      case CMP_SUBPAGES.CAREER_PATH:
      case CMP_SUBPAGES.FAQ:
        return `${cmpUrl}${subpageType}/`;
      case CMP_SUBPAGES.DYNAMIC:
        return `${cmpUrl}${customSubPageName}/`;
      case CMP_SUBPAGES.RESUME:
        return `${cmpUrl}resume/`;
      case CMP_SUBPAGES.WHAT_THEY_DO:
        // URL pattern of "Career What They Do" page: /<job-title>-jobs/what-does-<a/an>-<job-title>-do/
        return `${cmpUrl}what-does-${jobTitleArticle}-${jobTitleForUrl}-do/`;
      case CMP_SUBPAGES.HOW_TO_BECOME:
        // URL pattern of "How To Become" page: /<job-title>-jobs/how-to-become-<job-title-article>-<job-title>/
        return `${cmpUrl}how-to-become-${jobTitleArticle}-${jobTitleForUrl}/`;
      case CMP_SUBPAGES.HOW_TO_HIRE:
        // accountant-jobs/how-to-hire-an-accountant/
        return `${cmpUrl}how-to-hire-${jobTitleArticle}-${jobTitleForUrl}/`;
      default:
        // Default to return empty string if the subpageType is not in the defined list above.
        return cmpUrl;
    }
  }
  return '';
};

export const buildComboSalaryUrl = (jobTitle, jobLocation, host = '') => {
  let url = buildCmpSubpagesUrls(jobTitle, host, 'salary');
  let { city, state } = splitLocation(jobLocation);
  if (!city) {
    url += `${removeSpecialCharacter(getStateName(state).toLowerCase())}/`;
  } else {
    url += `${removeSpecialCharacter(jobLocation)}/`;
  }
  return buildUrl(url, host);
};

export const buildCompanyCategoryUrl = (category = '') => {
  const categoryUrl = buildUrl(category);
  return `/company/${categoryUrl}/`;
};

export const isLastCharacter = (myString, char) => {
  if (myString && char) {
    const lastcharacter = myString.charAt(myString.length - 1);
    return lastcharacter === char;
  }
  return false;
};

export const buildMajorPageUrl = (majorName = '') =>
  `/${removeSpecialCharacter(majorName)}${isLastCharacter(majorName, '-') ? 'major/' : '-major/'}`;

export const buildMajorSubPageUrl = (majorName = '', subPageName = '') => {
  const url = `/${removeSpecialCharacter(majorName)}-major/${subPageName}/`;
  return url.toLowerCase();
};

/**
 * @param {string} cppUrl - Required, pre-generated CPP Url from company-info-cps ES index (field name: zippiaCppUrl).
 * @param {*} adjective  - Requried
 * @param {string} host - Optional, send current host for absolute URL, otherwise keep it as empty for relative URL.
 * @returns Company Job Title Salary Page Url
 */
export const buildCompanyAdjectivePageUrl = (cppUrl, adjective, host = '') => {
  const cppJobUrl = buildCppSubpageUrl(cppUrl, host, CPP_SUBPAGES.JOBS);
  return cppJobUrl + removeSpecialCharacter(adjective)?.toLowerCase() + '/';
};

// set default company logo if src is broken
export const setDefaultCompanyLogoOnError = (event) => {
  event.target.src = DEFAULT_COMPANY_LOGO_SRC;
};

// set alt text to img (e.g. prevents text flickering when img is broken and default logo is being used)
export const setImgAltText = (event, altText) => {
  event.target.alt = altText;
};

export const openInNewTab = (link) => {
  if (link) {
    if (!link.match(/^https?:\/\//i) && !link.match(/^mailto?:/i) && link.indexOf('www') > -1) {
      link = 'http://' + link;
    }
    window.open(link, '_blank');
  }
};

export const openInCurrentTab = (link) => {
  if (link) {
    if (!link.match(/^https?:\/\//i) && link.indexOf('www') > -1) {
      link = 'http://' + link;
    }
    window.location.href = link;
  }
};

// return encoded url
export const decodeBase64 = (str) => window.atob(str);

export const setSessionData = (key, val) => {
  if (typeof Storage === 'undefined') return false;
  sessionStorage.setItem(key, typeof val !== 'string' ? JSON.stringify(val) : val);
  return true;
};

export const getCookie = (item) => {
  if (!isBrowser()) return '';
  if (!document.cookie) return '';
  const cookiesArr = document.cookie.split(';');
  let cookieResult;
  let cookieItem;
  for (let i = 0, l = cookiesArr.length; i < l; i++) {
    cookieItem = cookiesArr[i].split('=')[0].trim();
    if (item === cookieItem) {
      cookieResult = cookiesArr[i].split('=')[1].trim();
      return cookieResult;
    }
  }
  if (cookieResult === undefined) {
    return null;
  }
};

export const setCookie = ({ item, value, expiredays, path = '/', customExpireDays = '' }) => {
  // this can be used delete cookie
  const date = new Date();
  date.setTime(date.getTime() + expiredays * 24 * 60 * 60 * 1000);
  document.cookie = `${item}=${escape(value)};expires=${
    customExpireDays || date.toGMTString()
  };path=${path}`;
};

export const copyToClipboard = (copyPasteShare) => {
  const input = copyPasteShare.current;
  const isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);

  if (isiOSDevice) {
    const editable = input.contentEditable;
    const { readOnly } = input;

    input.contentEditable = true;
    input.readOnly = false;

    const range = document.createRange();
    range.selectNodeContents(input);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    input.setSelectionRange(0, 999999);
    input.contentEditable = editable;
    input.readOnly = readOnly;
  } else {
    input.select();
  }
  document.execCommand('copy');
};

export const freezeBodyScroll = (isDLP = false) => {
  const bodySelector = document.querySelector('body');
  if (!bodySelector || !window) {
    return;
  }
  const offsetTopFreezed = window.bodyFreezeOffsetTop;
  const offsetTop = bodySelector.style.top ? offsetTopFreezed : window.scrollY;
  const css = {
    top: `${-offsetTop}px`,
    right: 0,
    left: 0,
    bottom: 0,
    position: 'fixed',
    overflowY: isDLP ? 'scroll' : 'hidden',
    overflowX: 'hidden',
  };
  for (const prop in css) {
    bodySelector.style[prop] = css[prop];
  }
  // firefox & mobile safari
  window.bodyFreezeOffsetTop = offsetTop;
};

export const unFreezeBodyScroll = () => {
  const htmlSelector = document.querySelector('html');
  const bodySelector = document.querySelector('body');
  if (!htmlSelector || !bodySelector || !window) {
    return;
  }
  setTimeout(() => {
    bodySelector.removeAttribute('style');
    bodySelector.style.overflow = 'scroll';
    // firefox & mobile safari
    const offsetTop = window.bodyFreezeOffsetTop;
    delete window.bodyFreezeOffsetTop;
    htmlSelector.style.scrollBehavior = 'auto';
    if (offsetTop || offsetTop === 0) {
      window.scrollTo(0, offsetTop);
    }
    htmlSelector.style.scrollBehavior = null;
  }, 300);
};

export const isBlankString = (string) => !string || /^\s*$/.test(string);

// Safari doesn't support Object.fromEntries() until v12.1: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
// We will use the polyfill from https://github.com/microsoft/TypeScript/issues/32803 and https://github.com/tc39/proposal-object-from-entries/blob/master/polyfill.js
export const ObjectFromEntries = (iter) => {
  const obj = {};

  for (const pair of iter) {
    if (Object(pair) !== pair) {
      throw new TypeError('iterable for fromEntries should yield objects');
    }

    // Consistency with Map: contract is that entry has "0" and "1" keys, not
    // that it is an array or iterable.
    const { 0: key, 1: val } = pair;

    Object.defineProperty(obj, key, {
      configurable: true,
      enumerable: true,
      writable: true,
      value: val,
    });
  }
  return obj;
};

export const getUrlHostname = (url) => {
  if (!url) {
    return '';
  }
  return new URL(url).hostname;
};

export const addUserGroupToData = (data = {}) => {
  // if more a/b test, add here
  data.userGroup = {};
  const rbCheckoutOptimization = getCookie('_zippia-rbCheckoutOptimization');
  const redirectToCmp = getCookie('_zippia-redirectToCmp');
  const skillCardsUI = getCookie('_zippia-skillCardsUI');
  const recommendationsUpdate = getCookie('_zippia-recommendationsUpdate');
  const majorSurveyEntryPoints = getCookie('_zippia-majorSurveyEntryPoints');
  const majorPageHeroHeader = getCookie('_zippia-majorPageHeroHeader');
  const jobSearchSituation = getCookie('_zippia-jobSearchSituation');
  const surveyStepSituation = getCookie('_zippia-surveyStepSituation');
  const showJobScore = getCookie('_zippia-showJobScore');
  const paidFixedPos = getCookie('_zippia-paidFixedPos');
  const ltrCityPageUserGroup = getCookie('_zippia-LTRcityPage');
  const ltrComboCMPUserGroup = getCookie('_zippia-LTRcomboCMP');
  const signUp2ApplyPaidretestUserGroup = getCookie('_zippia-signUp2ApplyPaidretest');
  const incontentSignUpGPTAdvicePages = getCookie('_zippia-incontentSignUpGPTAdvicePages');
  const sponsoredInternalGateUserGroup = getCookie('_zippia-sponsoredInternalGate');
  const ltrCareerJobsPageUserGroup = getCookie('_zippia-LTRcareerJobs');
  const ltrcompanyJobsUserGroup = getCookie('_zippia-LTRcompanyJobs');
  const ltrEmployerJobs = getCookie('_zippia-LTRemployerJobs');
  const incontentSignUpCityPage = getCookie('_zippia-incontentSignUpCityPage');
  const incontentSignUpCmp = getCookie('_zippia-incontentSignUpCmp');
  const carouselsLocationFilter = getCookie('_zippia-CarouselsLocationFilter');

  if (redirectToCmp) data.userGroup.redirectToCmp = redirectToCmp;
  if (skillCardsUI) data.userGroup.skillCardsUI = skillCardsUI;
  if (recommendationsUpdate) data.userGroup.recommendationsUpdate = recommendationsUpdate;
  if (majorSurveyEntryPoints) data.userGroup.majorSurveyEntryPoints = majorSurveyEntryPoints;
  if (surveyStepSituation) data.userGroup.surveyStepSituation = surveyStepSituation;
  if (majorPageHeroHeader) data.userGroup.majorPageHeroHeader = majorPageHeroHeader;
  if (redirectToCmp) data.userGroup.redirectToCmp = redirectToCmp;
  if (jobSearchSituation) data.userGroup.jobSearchSituation = jobSearchSituation;
  if (showJobScore) data.userGroup.showJobScore = showJobScore;
  if (paidFixedPos) data.userGroup.paidFixedPos = paidFixedPos;
  if (rbCheckoutOptimization) data.userGroup.rbCheckoutOptimization = rbCheckoutOptimization;
  if (ltrCityPageUserGroup) data.userGroup.LTRcityPage = ltrCityPageUserGroup;
  if (ltrComboCMPUserGroup) data.userGroup.LTRcomboCMP = ltrComboCMPUserGroup;
  if (signUp2ApplyPaidretestUserGroup)
    data.userGroup.signUp2ApplyPaidretest = signUp2ApplyPaidretestUserGroup;
  if (incontentSignUpGPTAdvicePages)
    data.userGroup.incontentSignUpGPTAdvicePages = incontentSignUpGPTAdvicePages;
  if (ltrCareerJobsPageUserGroup) data.userGroup.LTRcareerJobs = ltrCareerJobsPageUserGroup;
  if (sponsoredInternalGateUserGroup)
    data.userGroup.sponsoredInternalGateUserGroup = sponsoredInternalGateUserGroup;
  if (ltrcompanyJobsUserGroup) data.userGroup.LTRcompanyJobs = ltrcompanyJobsUserGroup;
  if (ltrEmployerJobs) data.userGroup.LTRemployerJobs = ltrEmployerJobs;
  if (incontentSignUpCityPage) data.userGroup.incontentSignUpCityPage = incontentSignUpCityPage;
  if (incontentSignUpCmp) data.userGroup.incontentSignupCmp = incontentSignUpCmp;
  if (carouselsLocationFilter) data.userGroup.carouselsLocationFilter = carouselsLocationFilter;
};

export const parseUrlParam = (url) => {
  if (!url) return {};
  const urlParam = url.split('?')[1];
  const urlParamObj = {};
  if (urlParam) {
    const paramArr = urlParam.split('&');
    paramArr.forEach((item) => {
      const param = item.split('=');
      urlParamObj[param[0]] = param[1];
    });
  }
  return urlParamObj;
};

export const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};

export const appendParamToUrl = (url, paramName, paramValue) => {
  if (!isValidUrl(url) || !paramName || !paramValue) {
    return url;
  }
  const urlTemp = new URL(url);
  urlTemp.searchParams.append(paramName, paramValue);
  return urlTemp.href;
};

export const getRelatedLocation = (criteria, userLocation, recentUserData) => {
  const result = {};
  let city = '';
  let stateAbbr = '';
  if (criteria && criteria.stateAbbr) {
    // Use location of page if available,
    city = criteria.city;
    stateAbbr = criteria.stateAbbr;
  } else if (userLocation && userLocation.state) {
    // fallback to userLocation if available,
    city = userLocation.city;
    stateAbbr = userLocation.state;
  } else if (criteria && criteria.geoStateCode) {
    // fallback to geo-detected location if available
    city = criteria.geoCity;
    stateAbbr = criteria.geoStateCode;
  } else if (
    recentUserData &&
    recentUserData.recentUserLocation &&
    recentUserData.recentUserLocation[0] &&
    recentUserData.recentUserLocation[0].name
  ) {
    // fallback to recent user browsed location if available
    const userLocationArray = recentUserData.recentUserLocation[0].name.split(',');
    if (userLocationArray.length === 1) {
      // state only
      stateAbbr = getStateAbbr(userLocationArray[0].trim());
    } else if (userLocationArray.length === 2) {
      // state and city
      city = userLocationArray[0].trim();
      stateAbbr = getStateAbbr(userLocationArray[1].trim());
    }
  }
  return stateAbbr ? Object.assign(result, { city, state: stateAbbr }) : result;
};

export const formatStringDate = (stringInput) => {
  // Match the date in yyyyMMddHHmmss format, for example: 20200317112000
  const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
  // Format the time as yyyy-MM-dd HH:mm:ss
  return stringInput.replace(pattern, '$1/$2/$3 $4:$5:$6');
};

export const flattenUserGroup = (group, spliter = '+') => {
  let ret = '';
  if (typeof group === 'string') {
    return group;
  }
  if (!group || !_isObject(group)) {
    return ret;
  }
  ret = Object.keys(group)
    .map((key) => `${key}.${group[key]}`)
    .join(spliter);
  return ret;
};

export const buildLocationString = (city, state) => (city ? `${city}, ` : '') + state;

export const serializetoQuery = (params) => {
  const result = [];
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        const keyValue = params[key];
        if (keyValue) {
          switch (keyValue.constructor.name) {
            case 'Array':
              if (keyValue.length > 0) {
                if (key == 'locations') {
                  keyValue.forEach((location) => {
                    result.push(`${key}=${buildLocationString(location.city, location.state)}`);
                  });
                } else {
                  const joined_value = keyValue.join(',');
                  result.push(`${encodeURIComponent(key)}=${encodeURIComponent(joined_value)}`);
                }
              }
              break;
            default:
              result.push(`${encodeURIComponent(key)}=${encodeURIComponent(keyValue)}`);
          }
        }
      }
    });
    return result.join('&');
  }
  return result;
};

export const scrollTo = (target, duration, updateHash = true) => {
  const hash = target.includes('#') ? `${target.split('#')[1]}` : target;

  const clusterHeader = document.getElementById('navigation');
  const el = document.getElementById(hash);

  if (!el) {
    return;
  }

  const targetPos =
    el.getBoundingClientRect().top -
    (clusterHeader ? clusterHeader.getBoundingClientRect().height : 0);
  const startPos =
    window.pageYOffset - (clusterHeader ? clusterHeader.getBoundingClientRect().height : 0);

  let startTime = null;

  const ease = (t, b, c, d) => {
    const time = t / d;
    return -c * time * (time - 2) + b;
  };

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;

    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPos, targetPos, duration);
    window.scrollTo(0, run);

    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  if (updateHash) {
    setTimeout(() => {
      window.location.hash = hash;
    }, duration);
  }

  requestAnimationFrame(animation);
};

// Formatter for the currencies to US currencies
export const formatter = (isCompact) =>
  new Intl.NumberFormat(
    'en-US',
    isCompact
      ? {
          style: 'currency',
          currency: 'USD',
          notation: 'compact',
          compactDisplay: 'short',
        }
      : {
          style: 'currency',
          currency: 'USD',
          maximumSignificantDigits: 3,
        }
  );

export const formatSubPageText = (subPageName = '', clusterCategory = '') => {
  if (subPageName.includes('-')) {
    subPageName = subPageName.replace(/-/g, ' ');
    subPageName = subPageName
      .split(' ')
      .map((item) => item.slice(0, 1).toUpperCase() + item.slice(1));
    subPageName = subPageName.join(' ');
  }

  if (clusterCategory === CLUSTER_HEADER_CATEGORY.CAREER) {
    switch (subPageName) {
      case CMP_SUBPAGES.EDUCATION:
        return 'Education Requirements';
      case CMP_SUBPAGES.DEMOGRAPHICS:
        return 'demographics and statistics in the US';
      default:
        return subPageName;
    }
  } else if (clusterCategory === CLUSTER_HEADER_CATEGORY.COMPANY) {
    switch (subPageName) {
      case 'Executives':
        return 'CEO and Leadership';
      default:
        return subPageName;
    }
  } else {
    return subPageName;
  }
};

export const useInput = (initialValue = '', isNumber = false) => {
  const [value, setValue] = useState(initialValue);
  const [showError, setShowError] = useState(false);

  return {
    value,
    onChange: (event) => {
      if (isNumber) {
        setValue(event.target.value.replace(/\D/g, ''));
      } else {
        setValue(event.target.value);
      }
    },
    clear: () => {
      setValue('');
    },
    showError,
    displayError: () => setShowError(true),
    hideError: () => setShowError(false),
  };
};

export const generateGoogleLink = (str) => {
  if (str) {
    const query = str.replace(/[^A-Z0-9]+/gi, '+').trim();
    return `https://www.google.com/search?q=${query}`;
  }

  return str;
};

export const isURL = (url) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  return !!pattern.test(url);
};

export const getRemoteLocationText = (location) => (location ? `Remote or ${location}` : 'Remote');

export const resetObject = (o) => {
  Object.keys(o).forEach((key) => {
    const val = o[key];
    switch (typeof val) {
      case 'string':
        o[key] = '';
        break;
      case 'number':
        o[key] = 0;
        break;
      case 'boolean':
        o[key] = false;
        break;
      case 'object':
        if (val === null) {
          break;
        } else if (val instanceof Array) {
          o[key] = [];
          break;
        } else {
          o[key] = {};
        }
        break;
    }
  });
  return o;
};

export const isImageExist = (path) => {
  if (!path) return Promise.resolve({ path, status: 'error' });

  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve({ path, status: 'ok' });
    image.onerror = () => resolve({ path, status: 'error' });

    image.src = path;
  });
};

export const kFormatter = (num, kSign) =>
  Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + kSign
    : Math.sign(num) * Math.abs(num);

/**
 * Build location.
 *
 * @param {string} city.
 * @param {string} state.
 * @param {string} stateAbbr.
 */
export const buildFullLocation = (city, state, stateAbbr) => {
  if (city && stateAbbr) {
    return `${city}, ${stateAbbr}`;
  }
  if (state) {
    return state;
  }
  return '';
};

/**
 * Validating password
 *
 * @param {string} password.
 */
export const validatePasswordV2 = (password, confirmPassword = '') => {
  const inBlacklist = passwordBlacklist.some((item) => password.toLowerCase().includes(item));

  const isRepeating =
    password.split('').filter((l) => l === password[0]).length === password.length;

  if (password.length < 8) {
    return 'Password should be at least 8 characters long.';
  }
  if (inBlacklist || isRepeating) {
    return 'For your account security, please create a stronger password.';
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match';
  }
  return '';
};

export const checkLocalStorage = () => {
  let isLocalStorageAvailable;

  try {
    isLocalStorageAvailable = window && 'localStorage' in window && window.localStorage !== null;
  } catch (e) {
    isLocalStorageAvailable = false;
  }

  if (window && !isLocalStorageAvailable) {
    Object.defineProperty(window, 'localStorage', {
      value: {
        getItem() {
          return null;
        },
        setItem() {},
        removeItem() {},
        clear() {},
      },
    });
  }
};

const zippiaImageHosts = [
  'static.zippia.com',
  'media.dev.zippia.com',
  'www.zippia.com',
  'media.zippia.com',
  'dev.zippia.com',
];
/**
 * Check if image hosted on zippia domain.
 *
 * @param {string} imageUrl.
 */
export const isZippiaImage = (imageUrl) => {
  try {
    const url = new URL(imageUrl);
    if (zippiaImageHosts.includes(url.hostname)) {
      return true;
    }
    return false;
  } catch (err) {
    return false;
  }
};
export const startsWithCapital = (word) => {
  if (!word || typeof word !== 'string') {
    return false;
  }
  return word.charAt(0) === word.charAt(0).toUpperCase();
};

export const isAllCapitilized = (string) => {
  if (!string || typeof string !== 'string') {
    return false;
  }
  return string === _startCase(_toLower(string));
};

export const isValidLocationString = (locationString = '') => {
  if (typeof locationString !== 'string') {
    return false;
  }
  if (locationString === '') {
    return true;
  }

  let cityTemp;
  let stateTemp;

  const locationArr = locationString.split(',').map((item) => item.trim());
  if (locationArr.length === 1) {
    stateTemp = locationArr[0];
  } else if (locationArr.length === 2) {
    cityTemp = locationArr[0];
    stateTemp = locationArr[1];
  } else {
    return false;
  }

  if (cityTemp && !startsWithCapital(cityTemp)) {
    return false;
  }
  if (cityTemp && !isStateAbbr(stateTemp)) {
    return false;
  }
  if (!cityTemp && !isAllCapitilized(stateTemp)) {
    return false;
  }
  if (!cityTemp && !isStateName(stateTemp.toLowerCase())) {
    return false;
  }

  return true;
};

export function isJobSearchPage(url) {
  const splitted = url?.split('/') || [];

  if (!splitted.length) {
    return false;
  }

  if (url[0] === '/' && splitted[1] === 'job-search') {
    return true;
  }

  if (url[0] !== '/' && splitted[0] === 'job-search') {
    return true;
  }

  return false;
}

/**
 * Transforming to locale string
 *
 * @param {number} number
 * @returns 1000 => 1,000
 */
export function toLocale(number) {
  return Number(number).toLocaleString();
}

export const dateValid = (date, format = '') => dayjs(date, format).isValid();

export const dateFormat = (date, inputFormat, outputFormat = 'DD/MM/YYYY') => {
  if (!dateValid(date, inputFormat)) {
    return '';
  }
  return dayjs(date, inputFormat).format(outputFormat);
};

/**
 * Get theme font styles for resume template.
 *
 * @param {string} fontSize - font size
 * @param {string} lineHeight - line height
 */
export const getThemeTextSize = (fontSize, lineHeight) => ({
  fontSize,
  lineHeight,
});

/**
 * Get user location.
 *
 * @param {Object} userLocation
 * @param {Object} criteria
 */
export const getLocations = (userLocation, criteria) => {
  const locations = [];

  const pushLocation = (city, state, stateAbbr) =>
    locations.push({
      city,
      state,
      stateAbbr,
      displayName: buildFullLocation(city, state, stateAbbr),
      value: { city, state },
    });

  if (userLocation?.length) {
    userLocation.forEach((val) => {
      const { city } = val;
      const { state } = val;

      pushLocation(city, state, getStateAbbr(state));
    });
  } else if (criteria && (criteria.city || criteria.stateAbbr)) {
    const { city } = criteria;
    const { state } = criteria;
    const { stateAbbr } = criteria;

    pushLocation(city, state, stateAbbr);
  } else if (criteria && (criteria.geoCity || criteria.geoStateCode)) {
    const city = criteria.geoCity;
    const stateAbbr = criteria.geoStateCode;

    if (city && stateAbbr) pushLocation(city, stateAbbr, stateAbbr);
    else pushLocation(city, getStateName(stateAbbr), stateAbbr);
  }

  return locations;
};

/**
 * Get user or geo location.
 *
 * @param {Object} userLocation
 * @param {Object} criteria
 */
export const getUserOrGeoLocations = (userLocation, criteria) => {
  const locations = [];

  const pushLocation = (city, state, abbr) =>
    locations.push({
      city,
      state,
      displayName: buildFullLocation(city, state, abbr),
      value: { city, state },
    });

  if (userLocation?.length) {
    userLocation.forEach((val) => {
      const { city } = val;
      const { state } = val;

      pushLocation(city, state, getStateAbbr(state));
    });
  } else if (criteria && (criteria.geoCity || criteria.geoStateCode)) {
    const city = criteria.geoCity;
    const stateAbbr = criteria.geoStateCode;

    if (city && stateAbbr) pushLocation(city, stateAbbr, stateAbbr);
    else pushLocation(city, getStateName(stateAbbr), stateAbbr);
  }

  return locations;
};

export const easingFunctions = {
  // no easing, no acceleration
  linear: (t) => t,
  // accelerating from zero velocity
  easeInQuad: (t) => t * t,
  // decelerating to zero velocity
  easeOutQuad: (t) => t * (2 - t),
  // acceleration until halfway, then deceleration
  easeInOutQuad: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
  // accelerating from zero velocity
  easeInCubic: (t) => t * t * t,
  // decelerating to zero velocity
  easeOutCubic: (t) => --t * t * t + 1,
  // acceleration until halfway, then deceleration
  easeInOutCubic: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
  // accelerating from zero velocity
  easeInQuart: (t) => t * t * t * t,
  // decelerating to zero velocity
  easeOutQuart: (t) => 1 - --t * t * t * t,
  // acceleration until halfway, then deceleration
  easeInOutQuart: (t) => (t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t),
  // accelerating from zero velocity
  easeInQuint: (t) => t * t * t * t * t,
  // decelerating to zero velocity
  easeOutQuint: (t) => 1 + --t * t * t * t * t,
  // acceleration until halfway, then deceleration
  easeInOutQuint: (t) => (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t),
};

export const scrollWithEasing = (to, duration = 500, easeing = easingFunctions.linear) => {
  const requestAnimationFrame =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame;

  const start = window.scrollY || window.pageYOffset;
  const time = Date.now();

  (function step() {
    const dx = Math.min(1, (Date.now() - time) / duration);
    const pos = start + (to - start) * easeing(dx);

    window.scrollTo(0, pos);

    if (dx < 1) {
      requestAnimationFrame(step);
    }
  })();
};

export function formatEducationLabel(label) {
  switch (label) {
    case 'High School Diploma':
      return 'High School Diploma or Less';
    case 'Associate':
      return 'Some College/ Associate Degree';
    case 'Bachelors':
      return "Bachelor's Degree";
    case 'Masters':
      return "Master's Degree";
    case 'Doctorate':
      return 'Doctorate Degree';
    default:
      return label;
  }
}

export function getBarChartYLabels(values, order = 'desc', splitSize = 5, isYStartsZero) {
  const [yMinValue, yMaxValue] = [isYStartsZero ? 0 : Math.min(...values), Math.max(...values)];

  const stepSize = Math.ceil((yMaxValue - yMinValue) / splitSize / 1000) * 1000;

  return _range(isYStartsZero ? 0 : yMinValue - stepSize, yMaxValue + stepSize, stepSize)
    .map((value) => Math.ceil(value / 1000) * 1000)
    .sort((a, b) => (order === 'desc' ? b - a : a - b));
}

export function calculateBarLengthPercent(yLabels, value) {
  const labels = yLabels.sort((a, b) => b - a);
  const min = labels[labels.length - 1];
  const max = labels[0];
  const diff = max - min;
  return ((value - min) / diff) * 100;
}

/**
 * Convert yearly salary to hourly rate.
 *
 * Formula: salary / (40 hours * 52 weeks)
 *
 * @param {Number} salary
 */
export const yearlySalaryToHourlyRate = (salary) => Number(salary / HOURS_IN_YEAR).toFixed(2);

/**
 * Return 10 latest titles
 *
 * @param {Object} user
 */
export const getRecentTitles = (user) => {
  if (!user?.recentTitle?.length) return [];

  return user.recentTitle.slice(-10).map((title) => title.name);
};

export const mapLocationsForPaidJobs = (locations = []) =>
  locations.map(({ city, state, stateName }) =>
    city ? { city, state: getStateAbbr(state) } : { stateName: stateName || getStateName(state) }
  );

export const mapTitlesForPaidJobs = (title = '') =>
  title && title.length ? [{ normalizedTitle: title, originalSearch: title }] : [];

export const getNumPaidJobs = (pageSize, afterEveryX = 0, nStickyPaidJobs = 0) => {
  let numPaidJobs = 0;
  if (!afterEveryX && !nStickyPaidJobs) numPaidJobs = 0;
  else if (!afterEveryX && nStickyPaidJobs) numPaidJobs = nStickyPaidJobs;
  else numPaidJobs = nStickyPaidJobs + Math.floor((pageSize - nStickyPaidJobs) / (afterEveryX + 1));
  return numPaidJobs;
};

/**
 * This function is used to return a mixure of both paid and regular jobs
 * paginated over multiple pages by page size
 * @param {Array} regularJobs - Array of regular Jobs
 * @param {Array} paidJobs - Array of paid Jobs
 * @param {Number} pageSize - Page size (defaults to 20)
 * @param {Number} numPaidJobs - Number of paid jobs to be displayed per page
 * @param {Number} afterEveryX - Number by which we insert one paid job after every X
 * @param {Number} nStickyPaidJobs - Number of sticky paid jobs at corner of job bucket (defaults to 4)
 * @returns Paginated paid and regular jobs for all pages
 */
export function paginatePaidJobs(
  regularJobs = [],
  sponsoredJobs = [],
  pageSize = 20,
  numPaidJobs,
  afterEveryX,
  nStickyPaidJobs = 4
) {
  const paidJobs = sponsoredJobs.map((job) => ({
    ...job,
    isSponsored: true,
  }));

  if (!paidJobs.length) return regularJobs;
  if (!regularJobs.length) return paidJobs;

  const jobs = [];
  const nRJobs = pageSize - numPaidJobs;
  const remaining = numPaidJobs - nStickyPaidJobs;
  const totalPaidJobs = paidJobs.length;
  const totalRegularJobs = regularJobs.length;
  const total = totalRegularJobs + totalPaidJobs;

  let remainingPaidJobs = totalPaidJobs < numPaidJobs ? totalPaidJobs : numPaidJobs;
  let remainingRegularJobs = totalRegularJobs < nRJobs ? totalRegularJobs : nRJobs;

  let i, j;

  // For loop will iterate both paid and regular jobs page by page
  // taking pageSize jobs at one iteration
  for (i = 0, j = 0; i + j < total; i = i + remainingPaidJobs, j = j + remainingRegularJobs) {
    if (afterEveryX) {
      const half = Math.floor(nStickyPaidJobs / 2);
      jobs.push(...paidJobs.slice(i, i + half));
      const regularJobsPerPage = regularJobs.slice(j, j + nRJobs);
      let k = 0,
        l = 0;
      while (k < remaining || l < regularJobsPerPage.length) {
        jobs.push(...regularJobsPerPage.slice(l, l + afterEveryX));
        l += afterEveryX;
        if (k < remaining) {
          jobs.push(paidJobs[i + k + half]);
          k++;
        }
      }
      jobs.push(...paidJobs.slice(i + k + half, i + k + half + 2));
    } else {
      jobs.push(
        ...[
          ...paidJobs.slice(i, i + numPaidJobs / 2),
          ...regularJobs.slice(j, j + (pageSize - numPaidJobs)),
          ...paidJobs.slice(i + numPaidJobs / 2, i + numPaidJobs),
        ]
      );
    }
  }

  jobs.push(...paidJobs.slice(i));
  jobs.push(...regularJobs.slice(j));

  return jobs.filter((job) => !!job);
}

export const routerFormatUrl = (url) => (url.endsWith('/') ? url : `${url}/`);

export const monitorWindowUserId = (interval = 500, callback = () => null, maxAttempts = 100) => {
  if (!window) {
    return;
  }
  if (window.userId) return callback();
  let attempts = 1;
  const intervalId = setInterval(() => {
    if (attempts > maxAttempts) {
      // Don't try more than maxAttempts (default 100) times;
      return clearInterval(intervalId);
    }
    if (window.userId) {
      // If userId is found in window then call the callback
      callback();
      clearInterval(intervalId);
    }
    attempts += 1;
  }, interval);
};

/**
 * Computing string
 *
 * @param  {String | Object} args - strings or object of strings to combine
 */
export const computeString = (...args) => {
  const parts = [];

  args?.forEach((arg) => {
    if (arg && typeof arg === 'string') parts.push(arg);

    if (typeof arg === 'object' && !_isEmpty(arg) && !arg?.length) {
      Object.keys(arg).forEach((key) => {
        if (arg[key]) parts.push(key);
      });
    }
  });

  return parts.join(' ');
};

export const randomizedDefaultResumeTheme = () => {
  const resumeTemplataThemes = Object.values(RB_THEME);
  return resumeTemplataThemes[Math.floor(Math.random() * resumeTemplataThemes.length)];
};

/**
 * Importing from static server or local if project in running on localhost
 *
 * @param {String} url - import url
 */
export const importStaticOrFromLocal = (url) => (process?.env?.IS_LOCAL ? url : importStatic(url));

export const buildCitySubpageUrl = ({ city, stateAbbr }, subPageName, host = '') => {
  let Url = '';
  const cityUrl = buildUrlUsingTitleAndLocation('', city + '-' + stateAbbr, host);

  switch (subPageName) {
    case CITY_SUBPAGES.JOB:
      Url = cityUrl;
      break;
    case CITY_SUBPAGES.SALARY:
      Url = cityUrl + 'salary/';
      break;
    case CITY_SUBPAGES.PART_TIME_JOBS:
      Url = cityUrl + 'part-time-jobs/';
      break;
    default:
      Url = cityUrl + (subPageName ? removeSpecialCharacter(subPageName) + '/' : '');
      break;
  }

  return Url;
};

/**
 *
 * @param {String} string
 * @param {number} minWordLengthToHyphenate - min length of the word to hyphenate e.g if 4 then "Hell-o Worl-d Mary Gove-rnme-nt"
 */
export const hyphenateString = (string = '', minWordLengthToHyphenate) => {
  // can't be less than 1 because that will trigger infinite loop
  if (minWordLengthToHyphenate < 1 || !minWordLengthToHyphenate) {
    return string;
  }
  const words = string.split(' ');
  return words
    .map((word) => {
      let loopCount = 0;
      const MAX_LOOP = 20; // just in case to ensure no infinite loop
      let newString = '';
      let startPosition = 0;
      while (word.length > startPosition) {
        loopCount++;
        newString += word.slice(startPosition, startPosition + minWordLengthToHyphenate);
        startPosition += minWordLengthToHyphenate;

        if (startPosition < word.length) {
          newString += '-';
        }

        // just in case to ensure no infinite loop
        if (loopCount >= MAX_LOOP) {
          break;
        }
      }

      return newString;
    })
    .join(' ');
};

const calculatePages = (height, pageHeight, spacing = 0) => {
  const modulo = height % pageHeight;

  if (modulo > 0 && modulo <= spacing) {
    return Math.floor(height / pageHeight);
  }

  return Math.ceil(height / pageHeight);
};

const distanceFromLatLong = (lat1, lat2, lon1, lon2) => {
  // The math module contains a function
  // named toRadians which converts from
  // degrees to radians.
  const deg2rad = Math.PI / 180;
  lat1 *= deg2rad;
  lon1 *= deg2rad;
  lat2 *= deg2rad;
  lon2 *= deg2rad;

  // Haversine formula
  let dlon = lon2 - lon1;
  let dlat = lat2 - lat1;
  let a =
    Math.pow(Math.sin(dlat / 2), 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dlon / 2), 2);

  let c = 2 * Math.asin(Math.sqrt(a));

  // Radius of earth in kilometers. Use 3956
  // for miles
  let r = 3956;

  // calculate the result
  return Math.round(c * r);
};

/*
 * Computing height of template for render
 *
 * @param {number} size - height of template
 * @returns {number} height
 */
export const calculateSizeOfTemplate = (size = 1) => {
  const printPageHeight = 990; // height of PDF page
  const sideSpacing = 36;
  const spacing = sideSpacing * 2; // height of spacing at the top and bottom of the page
  const scaling = 0.75; // 1px = 0.75pt

  let heightInPt = size * scaling; // resume height in pt
  let pages = calculatePages(heightInPt, printPageHeight);

  if (pages) {
    heightInPt += spacing * (pages - 1); // resume heignt in pt including spaces on each page
    pages = calculatePages(heightInPt, printPageHeight, sideSpacing);
  }

  return printPageHeight * pages;
};

/**
 *
 * @param template - template component
 * @param {number} size - height of template
 * @param {string} theme - type of template
 * @returns {string} html code for render
 */
export const getResumeRenderHtml = (template, size, theme) => {
  const sheet = new ServerStyleSheet();
  const html = renderToString(
    <StyleSheetManager sheet={sheet.instance}>{template}</StyleSheetManager>
  );
  const styleTags = sheet.getStyleTags(); // or sheet.getStyleElement();
  const height = calculateSizeOfTemplate(size, theme);

  const htmlParts = [];
  const cleanupRegex = /\n\s+/g;

  const stringifyHTML = (str) => str.replace(cleanupRegex, '');

  htmlParts.push(stringifyHTML(`
    <!DOCTYPE html>
      <html>
        <head>
          <style>
            @media print {
              html,
              body {
                margin: 0;
              }

              .avoid-break {
                break-inside: avoid;
              }

              .auto-inside-break {
                break-inside: auto;
              }

              .emailLink, .emailLink:hover {
                outline: medium none !important;
                text-decoration: none !important;
                cursor: pointer;
                color: inherit;
              }

              div[data-section-highlighted="true"]::before {
                display: none !important;
              }

              .template-height {
                height: calc(${height}pt - 120px);
              }
            }
          </style>
  `))
  htmlParts.push(styleTags)
  htmlParts.push(stringifyHTML(`
    </head>
    <body style="height: ${height}pt; overflow: hidden;">
      <style>
        @media print {
            .text-lines p, li {
                break-inside: avoid;
            }
        }
      </style>
  `))
  htmlParts.push(html)
  htmlParts.push('</body></html>');

  return htmlParts.join('');
};

/**
 * Builds a URL from a job object.
 * Location can be {city}-{st}, {stateName} or {remote}.
 * The resulting URL starts with a slash!
 * @param {import('types').Job} job
 * @returns /job-listing/{location}/{job-title}/{listingHash}/
 */
export const buildDlpUrl = (job = {}) => {
  const { location = '', listingHash = '' } = job;
  const title = job.titleID || job.jobTitle || '';
  if (!title && !location && !listingHash) return '';
  const locationCheck = location || 'remote';
  const locationEncoded = locationCheck.replace(', ', '-').replace(/\s/g, '-').toLowerCase();
  const titleEncoded = removeSpecialCharacter(title).toLowerCase();
  const newUrl = `/job-listing/${locationEncoded}/${titleEncoded}/${listingHash}/`;
  return newUrl;
};

export const formatNumberWithIntl = (
  value,
  options = {
    maximumSignificantDigits: 2,
  }
) => new Intl.NumberFormat('en-US', options).format(value);

export const filterOnlyUSLocations = (payload = {}) => {
  const newPayload = { ...payload };
  if (newPayload.locations?.length) {
    // Filter for non-US locations
    newPayload.locations = newPayload.locations.filter((location) => {
      return (
        (location.state || location.stateCode || location.stateName) &&
        (!!STATE_NAME[location.state] ||
          !!STATE_NAME[location.stateCode] ||
          !!STATE_ABBREV[location.stateName?.toLowerCase()] ||
          !!STATE_ABBREV[location.state?.toLowerCase()])
      );
    });
  }
  return newPayload;
};

// FRON-6072: add hack to show sponosored tags when dlp from foreign-worker
// left the above hack and added to show sponosored flag if sponosorship status might sponsor and we are on company/jobs page
export const doForceSponsor = (job) => {
  const href = window?.location?.href || '';
  const { visaStatus, companyID } = job;

  return (
    href.indexOf('/job-search/foreign-worker-jobs/') > 0 ||
    (visaStatus === 'might_sponsor' && href.indexOf(`careers-${companyID}/jobs/`) > 0)
  );
};

/**
 * Is remote job
 *
 * @param {String} tags
 */
export const isRemoteJob = (tags = '') => tags.includes('Remote');

/**
 * Always Settle promise
 * @param {string} req Request Object
 * @param {Promise<any>[]} promises Promise Array
 * @returns {Promise<any>[]} Array of settled promise response
 */
export const promisesSettled = async (promises) => {
  const statuses = await Promise.allSettled(promises);

  return statuses.map(({ status, value }) => {
    if (status === 'fulfilled') {
      return value;
    }

    return null;
  });
};

/**
 * @returns Boolean if you're browsing storybook then it will return true otherwise returns false
 */
export function isStorybookEnv() {
  const IS_STORYBOOK_ENV =
    typeof window === 'object'
      ? window?.location?.pathname?.includes('/storybook/') ||
        window?.location?.host?.includes('localhost:6006')
      : false;

  return IS_STORYBOOK_ENV;
}

export const hexToRgb = (colorInHex = '') => {
  if (colorInHex[0] !== '#') {
    return {
      r: 255,
      g: 255,
      b: 255,
    };
  }
  let hex = colorInHex.slice();
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (_, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const cleanHTMLContent = (content) => {
  const LIST_TAGS = ['ul', 'ol'];
  const SPLIT_REGEX = /<[p|br|/p]+>/;

  return content
    .split(SPLIT_REGEX)
    .reduce((acc, str) => {
      const cleanStr = str.trim();

      if (!cleanStr) {
        return acc;
      }

      const isList = cleanStr[0] === '<' && LIST_TAGS.includes(cleanStr.substring(1, 3));

      if (isList) {
        return [...acc, cleanStr];
      }

      return [...acc, `<p>${cleanStr}</p>`];
    }, [])
    .join('');
};

/**
 * Safest, non-library-dependant method to strip all HTML markup from strings.
 * Does not work server-side.
 * https://stackoverflow.com/questions/822452/strip-html-from-text-javascript
 * @param {string} html
 * @returns {string}
 */
export const stripHtml = (html) => {
  if (window === undefined) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

export const filterBadValues = (array = []) =>
  array.filter((item) => item !== null && item !== undefined);

// Converting symbols to HTML entities
// Right now only supporting & symbol
// Looks like other symbols are displaying correctly
// After converting from draft to HTML in RichTextInput
export const toHTMLEntities = (string) => string.replace(/&/g, '&amp;');

/**
 * Removing extra break (\r or \n)
 *
 * @param {String} string
 */
export const removeBreaks = (string) => string.replace(/(\r\n|\n|\r)/gm, '').replace(/\s+/g, ' ');

export const getArticleContentBySubType = (subType, articles) => {
  if (!articles && !Array.isArray(articles)) {
    return null;
  }

  return articles.find(({ post_subtype: postSubType }) => postSubType === subType);
};

export const arrayToMatrix = (array, columns) =>
  Array(Math.ceil(array.length / columns))
    .fill('')
    .reduce((acc, cur, index) => [...acc, [...array].splice(index * columns, columns)], []);

export const filterResumeSocials = (data) =>
  [...(data?.socials?.items || []), ...(data?.portfolios?.items || [])].filter((item) => item.url);

export const formatRBFreeInput = (str) =>
  str
    .replace(/\s+/g, ' ')
    .replace(/[^a-zA-z0-9\s+?.,=\-{}<>!/@#$%&*()]/g, '')
    .trim();

export const isUserOutsideUS = (criteria = {}) => criteria?.geoCountryCode !== 'US';

export const getDistanceInMiles = (lat, long, objCity, objState) => {
  const location = getCityLatLong(objCity, objState);
  if (!location) {
    return 0;
  }
  return distanceFromLatLong(lat, location.LATITUDE, long, location.LONGITUDE);
};
export const isInternalGateCategoryPage = (category = '') => {
  const validCategories = [
    'Site Map State',
    'City Page',
    'City $15 Per Hour Jobs Page',
    'City $20 Per Hour Jobs Page',
    'City Remote Jobs Page',
    'City Part Time Jobs Page',
    'City Full Time Jobs Page',
    'City Hiring Immediately Jobs Page',
    'City Entry Level Jobs Page',
    'Career Jobs Page',
    'Career Remote Jobs Page',
    'Career Part Time Jobs Page',
    'Career Entry Level Jobs Page',
    'Career Full Time Jobs Page',
    'Career Work From Home Jobs Page',
    'City Work From Home Jobs Page',
    'City Teen Jobs Page',
    'Company Jobs Page',
    'Company Part Time Jobs Page',
    'Company Remote Jobs Page',
    'Career Main Page - Job + City',
  ];
  return validCategories.indexOf(category) >= 0;
};

export const isDistanceInMilesCategoryPage = (category = '') => {
  const validCategories = [
    'City Page',
    'Career Main Page - Job + City',
    'City Part Time Jobs Page',
    'City $15 Per Hour Jobs Page',
    'City $20 Per Hour Jobs Page',
    'City Remote Jobs Page',
    'City Full Time Jobs Page',
    'City Hiring Immediately Jobs Page',
    'City Entry Level Jobs Page',
  ];
  return validCategories.indexOf(category) >= 0;
};

/**
 * Calculate # of days from start date to current date
 * @param {string | Date} startDate
 * @returns {number} Number of days
 */
export const daysAgo = (startDate) => {
  return Math.floor(dayjs(Date.now()).diff(startDate) / (1000 * 3600 * 24));
};
